import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit form': 'search',
  },

  initialize({ placeholder, apiModeSelection }) {
    this.listenTo(this.collection, 'filtered', this.clearSearch);
    this.apiModeSelection = apiModeSelection;
    this.placeholder = placeholder;
  },

  context() {
    return {
      placeholder: this.placeholder,
    };
  },

  clearSearch() {
    this.$('input').val('');
  },

  search(e) {
    if (e) { e.preventDefault(); }

    const term = (this.$('input').val() || '').trim();
    if (term.length > 0) {
      this.searchTerm(term);
    } else {
      this.collection.resetToFirstPage();
    }
  },

  searchTerm(term) {
    /* Override this method to perform a custom search */
    this.collection.searchById(term, this.apiModeSelection);
  },
});



// WEBPACK FOOTER //
// ./app/components/list/search/index.js